import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../RootState';
import * as API from './api';
import { ExpandValidityResponse } from './state';
import { createTicket, updateTicket } from 'src/apis/tickets';
import { TicketStatusID } from 'src/models/TicketStatus';
import { setPagination } from '../ui/uiSlice';

export const getExpandValidity = createAsyncThunk<
    ExpandValidityResponse,
    { page?: number; selectedTab?: string, searchValue?: string},
    {
        state: RootState;
        rejectValue: string;
    }
>('expand_validity/getExpandValidity', async ({ page, selectedTab, searchValue }: { page?: number; selectedTab?: string, searchValue?:string }, thunkAPI) => {
    const numPage = page ?? 1;
    const search = searchValue ?? '';
    const {
        User: { token },
    } = thunkAPI.getState();
    try {
        const response = await API.getExpandValidity({ token, page: numPage, selectedTab, search });
        if (response.pagination) {
            thunkAPI.dispatch(setPagination(response.pagination));
        }

        return response;
    } catch (error) {
        // Maneja otros errores
        return thunkAPI.rejectWithValue('Error de red');
    }
});

export const updateExpandValidity = createAsyncThunk<
    [],
    { data: any },
    {
        state: RootState;
        rejectValue: string;
    }
>('expand_validity/updateExpandValidity', async (data: any, thunkAPI) => {
    const {
        User: { token },
    } = thunkAPI.getState();
    try {
        const dataUpdate = {
            ticket_id: data.ticket_id,
            user_id: data.user_id,
        };
        const response = await API.updateExpandValidity({ token, data: dataUpdate });
        if (response.success) {
            thunkAPI.dispatch(updateTicketExpandValidity({ ...data, ticket_id: data.ticket_id, ticket_status: TicketStatusID.active }));
        }
        return response;
    } catch (error) {
        // Maneja otros errores
        return thunkAPI.rejectWithValue('Error de red');
    }
});

export const createTicketExpandValidity = createAsyncThunk('expand_validity/createTicketExpandValidity', async (data: any, thunkAPI: any) => {
    const {
        User: { token },
    } = thunkAPI.getState();

    const dataCreate = {
        country: 'MX',
        register_id: data.id,
        user_id: data.user_id,
        ticket_type: 'expand-validity',
    };

    try {
        const response = await createTicket(dataCreate, token);
        if (response.ticket_id) {
            thunkAPI.dispatch(updateExpandValidity({ ...data, ticket_id: response.ticket_id }));
            return { id: data.id, changes: { ticket_id: response.ticket_id, ...data } };
        }
    } catch (error) {
        // Maneja otros errores
        return thunkAPI.rejectWithValue('Error de red');
    }
});

export const updateTicketExpandValidity = createAsyncThunk('expand_validity/updateTicketExpandValidity', async (data: any, thunkAPI: any) => {
    const {
        User: { token, name },
    } = thunkAPI.getState();

    let newData = {
        country: 'MX',
        ...data,
        // se asigna id de tabla ticket para el update
        register_id: data.id,
    };
    if ('note_content' in data) {
        const dataNote = {
            note_updated_at: new Date(),
            note_updated_by_fullname: name,
        };
        newData = {
            ...newData,
            ...dataNote,
        };
        data = {
            ...data,
            ...dataNote,
        };
    }

    delete newData.id;
    try {
        const response = await updateTicket(newData, token);
        if (response.success) {
            return { id: data.id, changes: data };
        } else {
            return thunkAPI.rejectWithValue('Error en actualizar');
        }
    } catch (error) {
        // Maneja otros errores
        return thunkAPI.rejectWithValue('Error de red');
    }
});
